import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    headerRoot: {
        position: "sticky",
        top: 0,
        background: "#fff",
        zIndex: 100
    },
    center: {
        textAlign: "center"
    },
    backButton: {
        marginRight: theme.spacing(1),
    },
    instructions: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
    stepper: {
        [theme.breakpoints.down('md')]:{
            display: 'none'
        }
    },
    responsiveStepper: {
        display: 'none',
        [theme.breakpoints.down('md')]:{
            display: 'flex'
        }
    },
    stepperActions: {
        padding: '5rem',
        flexDirection: 'row',
        justifyContent: 'flex-end',
        [theme.breakpoints.down(600)]:{
            padding: '3rem'
        },
        [theme.breakpoints.down(450)]:{
            padding: '1rem',
        },
        [theme.breakpoints.down(400)]:{
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center'
        }
    },
    responsiveStepIcon: {
        display: 'flex',
        justifyContent: 'center',
        transform: "scale(2)"
    },
    responsiveStepHeader: {
        display: 'flex',
        justifyContent: 'space-evenly',
        flexDirection: 'column',
        alignItems: 'center'
    },
    responsiveStepTitle:{
        width: 'fit-content',
        paddingTop: '3rem',
        fontSize: '1.5rem'
    }
}));


export default useStyles;